import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import appConfig from 'configs/app.config'
import useAuth from 'utils/hooks/useAuth'
import { ADMIN, USER } from 'constants/roles.constant'
import { useSelector } from 'react-redux'

const { authenticatedEntryPath } = appConfig

const PublicRoute = () => {
    const { authenticated } = useAuth()
    const userAuthority = useSelector((state) => state.auth.user.authority)

    return authenticated &&
        (userAuthority.includes(USER) || userAuthority.includes(ADMIN)) ? (
        <Navigate to={authenticatedEntryPath} />
    ) : (
        <Outlet />
    )
}

export default PublicRoute
